import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { settingTransparency } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetTransparency(refetch: () => void) {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingTransparencyPayload) => {
            return settingTransparency(payload)
        },
        onSuccess: (data, variables) => {
            const { moneyPool, ...toggles } = variables
            posthog.capture('fund_setting_transparency_saved', {
                fund_id: moneyPool,
                ...toggles,
            })
            refetch()
            toast.success('تغییرات با موفقیت انجام شد')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_setting_save_failed', {
                section: 'transparency',
                fund_id: variables?.moneyPool,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
